<div class="validation-error">
    <div class="responsive-flex-wrapper">
        <i class="fa fa-times-circle" [style.color]="'red'"></i>
    </div>
    <div class="error-message">{{ error }}</div>
</div>
